import { Component } from '@angular/core';

import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-fantasy-leaderboard',
  templateUrl: './fantasy-leaderboard.component.html',
  styleUrls: ['./fantasy-leaderboard.component.scss'],
})
export class FantasyLeaderboardComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;
}
